export const MENU_ITEMS = [
  {
    key: "/pages",
    label: "PAGES",
  },
  {
    key: "/posts",
    label: "POSTS",
  },
  {
    key: "/setting",
    label: "SETTING",
  },
];
